import { render, staticRenderFns } from "./takeaway_general_tab.vue?vue&type=template&id=63c7b35a&scoped=true&"
import script from "./takeaway_general_tab.vue?vue&type=script&lang=js&"
export * from "./takeaway_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7b35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c7b35a')) {
      api.createRecord('63c7b35a', component.options)
    } else {
      api.reload('63c7b35a', component.options)
    }
    module.hot.accept("./takeaway_general_tab.vue?vue&type=template&id=63c7b35a&scoped=true&", function () {
      api.rerender('63c7b35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/takeaway/location/tabs/takeaway_general_tab.vue"
export default component.exports